<template>
  <div class="pftable" :style="{'--defwidth':`${defwidth}px`}" :class="{'pftable_lesspad': lesspad, 'pftable_thin': thin, 'pftable_space': space}">
    <div class="tariffline" :class="{'tariffline_nobottom':index == lines.length - 1, 'tariffline_total': (expandable && expanded) && (index == lines.length - 1), 'tariffline_dotted': line[0].includes('withtooltip')}" v-for="(line, index) in lines" :key="index" v-show="(!expandable || (expandable && expanded))?true:(index>1?false:true)">
      <div class="tariffline__left">
        <div class="tariffline__name" v-html="line[0]"></div>
      </div>
      <div class="tariffline__price" v-html="line[1]"></div>
    </div>
    <button v-if="expandable" @click.stop.prevent="toggleExpanded" class="pfslide5link" href="./">Посмотреть подробности
        <svg :style="{'transform-origin': 'center center', transform: expanded? 'rotate(180deg)':'none'}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7 9.5L12 14.5L17 9.5" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
    </button>
  </div>
</template>

<script>
  export default {
    data: ()=>({
      expanded: false
    }),
    methods: {
      toggleExpanded(){
        this.expanded = !this.expanded
        this.$nextTick(()=>this.$emit('update'))
      }
    },
    computed: {
      currentLines() {
        if (this.expandable && !this.expanded)
          return this.lines.slice(0,2)
        return this.lines
      }
    },
    props: {
      lines: {type: Array, require: true},
      lesspad: {type: Boolean, default: false},
      expandable: {type: Boolean, default: false},
      thin: {type: Boolean, default: false},
      space: {type: Boolean, default: false},
      defwidth: {type: Number, default: 180}
    }
  }
</script>

<style lang="sass">
.pftable
  position: relative
  z-index: 1
  --defwidth: 180px
  width: 100%
  background: colors.$mainbg
  padding: 34px 24px 32px
  
  &_lesspad
    padding: 24px 0 24px
  @include for-mob
    padding: 16px 0
  .tariffline
    padding: 18.05px 0
    &, *
      line-height: 1.12
      border-color: #F6F8FA !important
  .tariffline__name
    color: colors.$bluefont5b
  &_thin .tariffline
    padding: 15px 0
  &_space
    margin-bottom: 60px

  .tariffline__left
    max-width: 100%
    margin-right: 32px
  .tariffline__price
    @include since(768px)
      width: var(--defwidth)
      text-align: left
    max-width: 400px
    text-align: right
  .tariffline__pricespace
    margin-top: 12px
  @include for-mob
    .tariffline
      display: flex
      padding: 13.3px 0
      &__pricespace
        margin-top: 4px
      &__left, &__name
        font-size: 14px
        line-height: 1.12
        width: auto
        max-width: initial
        flex-grow: 1
        margin-bottom: 0
      &__price
        min-width: 85px
        flex-shrink: 0
        font-weight: 500
        font-size: 16px
        max-width: initial
        width: auto
        flex-shrink: 1
        line-height: 1.12
</style>